/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! GhostStat Visitor Lifetime — viewer. */
(function () {

    function _rpT(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
    function _rpYmd(d){return d.getUTCFullYear()+"-"+("0"+(d.getUTCMonth()+1)).slice(-2)+"-"+("0"+d.getUTCDate()).slice(-2);}
    function _rpToday(){var n=new Date();return new Date(Date.UTC(n.getUTCFullYear(),n.getUTCMonth(),n.getUTCDate()));}
    function preset(days){var to=_rpToday(),from=new Date(to.getTime()-(days-1)*86400000);var lbl={7:_rpT("an.last7"),30:_rpT("an.last30"),90:_rpT("an.last90"),365:_rpT("an.last12mo")}[days]||(days+" days");return {from:_rpYmd(from),to:_rpYmd(to),label:lbl,preset:String(days)};}
    var RANGE=(function(){try{var s=JSON.parse(localStorage.getItem("gs_vl_range")||"null");if(s&&s.preset)return preset(+s.preset);if(s&&s.from&&s.to)return s;}catch(e){}return preset(30);})();
    function _rpInit(){
      var btn=document.querySelector('[data-vl="rangeBtn"]'),menu=document.querySelector('[data-vl="rangeMenu"]'),lab=document.querySelector('[data-vl="range-label"]');
      if(!btn||!menu)return;
      if(lab&&RANGE.label)lab.textContent=RANGE.label;
      function sync(){menu.querySelectorAll(".rm[data-preset]").forEach(function(x){x.classList.toggle("on",x.getAttribute("data-preset")===RANGE.preset);});}
      btn.addEventListener("click",function(e){if(menu.contains(e.target)&&e.target!==btn)return;e.stopPropagation();var open=menu.style.display!=="none";menu.style.display=open?"none":"block";if(!open){var cf=menu.querySelector('[data-rp="from"]'),ct=menu.querySelector('[data-rp="to"]');if(cf)cf.value=RANGE.from;if(ct)ct.value=RANGE.to;sync();}});
      document.addEventListener("click",function(e){if(!btn.contains(e.target))menu.style.display="none";});
      function apply(r){RANGE=r;if(lab)lab.textContent=RANGE.label;try{localStorage.setItem("gs_vl_range",JSON.stringify(RANGE));}catch(e){}menu.style.display="none";load();}
      menu.querySelectorAll(".rm[data-preset]").forEach(function(b){b.addEventListener("click",function(){apply(preset(+b.getAttribute("data-preset")));});});
      var ap=menu.querySelector('[data-rp="apply"]');if(ap)ap.addEventListener("click",function(){var ff=menu.querySelector('[data-rp="from"]').value,tt=menu.querySelector('[data-rp="to"]').value;if(!ff||!tt)return;if(ff>tt){var x=ff;ff=tt;tt=x;}apply({from:ff,to:tt,label:ff+" \u2192 "+tt,preset:null});});
    }


  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  function segScope(sg){var h=document.querySelector('[data-segtitle]');if(!h||!sg||!sg.name)return;var s=h.querySelector('.gs-seg-scope');if(!s){s=document.createElement('span');s.className='gs-seg-scope';s.style.cssText='color:#6B7280;font-weight:500;font-size:.6em;margin-left:7px;letter-spacing:normal;vertical-align:middle';h.appendChild(s);}s.textContent='\u00b7 '+sg.name;}
  var root = document.querySelector('[data-vl="root"]');
  if (!root) return;
  var C = { AC: "#1FA463", RD: "#DC2626", AM: "#D97706", MU: "#8C95A1" };
  function q(k) { return root.querySelector('[data-vl="' + k + '"]'); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function nf(n) { n = +n || 0; return n >= 1e3 ? (n / 1e3).toFixed(1) + "k" : String(n); }

  /* Stitching off is not an empty state, it is an explanation — so it replaces the page rather
     than sitting above a grid of zeros that would read as a business result. */
  function renderGate(d) {
    var gate = q("gate"), body = q("body");
    if (d.ok) { if (gate) gate.hidden = true; if (body) body.hidden = false; return true; }
    if (body) body.hidden = true;
    if (gate) {
      gate.hidden = false;
      gate.innerHTML = '<div class="vlt-gate-in"><b>'+TT('vlt.js_lifetime_na')+'</b>'
        + "<p>" + esc((d.identity && d.identity.reason) || "") + "</p>"
        + '<a class="vlt-gate-link" href="/site-settings">'+TT('visi.js.open_site_settings')+'</a></div>';
    }
    return false;
  }

  function renderBuckets(d) {
    var host = q("buckets"); if (!host) return;
    var b = d.buckets || [], c = d.cadence || {};
    var max = Math.max.apply(null, b.map(function (x) { return x.visitors; }).concat([1]));
    var col = { "one-and-done": C.RD, returning: C.AM, loyal: C.AC };
    host.innerHTML = b.map(function (x) {
      return '<div class="vlt-b"><div class="vlt-b-h"><span>' + esc(x.label) + "</span>"
        + "<b>" + nf(x.visitors) + " · " + x.share + "%</b></div>"
        + '<i class="vlt-b-bar"><b style="width:' + Math.max(2, Math.round(x.visitors / max * 100))
        + "%;background:" + (col[x.key] || C.MU) + '"></b></i></div>';
    }).join("")
    + '<div class="vlt-sum">' + nf(c.visitors || 0) + " identified visitors · <b>" + (c.returned_pct || 0)
    + "%</b> came back"
    + (c.avg_gap_d != null ? " · typically every <b>" + c.avg_gap_d + "</b> days" : "")
    + (c.median_span_d ? " · median span <b>" + c.median_span_d + "</b> days" : "") + "</div>";
  }

  function renderEvolution(d) {
    var host = q("evolution"); if (!host) return;
    var e = d.evolution;
    if (!e) { host.innerHTML = '<div class="empty">'+TR('visito.g.enable_visitor_intelligence_to_compa')+'</div>'; return; }
    if (!e.visitors) { host.innerHTML = '<div class="empty">'+TR('visito.f2.no_visitor_has_more_than_one_score')+'</div>'; return; }
    var rows = [[TR('visito.g.warmer'), e.warmer, C.AC], [TT('vlt.m.about_the_same'), e.flat, C.MU], [TR('visito.g.colder'), e.colder, C.RD]];
    var max = Math.max(e.warmer, e.flat, e.colder, 1);
    host.innerHTML = rows.map(function (r) {
      return '<div class="vlt-b"><div class="vlt-b-h"><span>' + r[0] + "</span><b>" + nf(r[1]) + "</b></div>"
        + '<i class="vlt-b-bar"><b style="width:' + Math.max(2, Math.round(r[1] / max * 100))
        + "%;background:" + r[2] + '"></b></i></div>';
    }).join("")
    + '<div class="vlt-sum">Across ' + nf(e.visitors) + " returning visitor" + (e.visitors === 1 ? "" : "s")
    + ", intent moves <b>" + (e.avg_delta > 0 ? "+" : "") + e.avg_delta + "</b> points on average between "
    + "the first visit and the latest.</div>";
  }

  function renderSurvival(d) {
    var host = q("survival"); if (!host) return;
    var w = d.survival || [];
    if (!w.length) { host.innerHTML = '<div class="empty">'+TR('visito.no_joining_weeks_in_this_range')+'</div>'; return; }
    host.innerHTML = w.map(function (x) {
      return '<div class="vlt-w-row"><span class="vlt-w-k">' + esc(x.week) + "</span>"
        + '<span class="vlt-w-n">' + nf(x.joined) + " joined</span>"
        + '<i class="vlt-w-bar"><b style="width:' + Math.max(1, x.returned_pct) + '%;background:' + C.AC + '"></b>'
        + '<u style="width:' + Math.max(0, x.loyal_pct) + '%;background:#0d7a4a"></u></i>'
        + '<span class="vlt-w-p">' + x.returned_pct + "% back · " + x.loyal_pct + "% loyal</span></div>";
    }).join("")
    + '<div class="vlt-key gs-muted">bar = returned · darker = became loyal (5+ visits)</div>';
  }

  function load() {
    if (!window.GS || !GS.api || !GS.site) return;
    var f = q("from"), t = q("to");
    GS.api("/plugin/visitor-lifetime/overview?site=" + encodeURIComponent(GS.site)
           + "&from=" + RANGE.from + "&to=" + RANGE.to)
      .then(function (r) {
        var d = (r && r.data) ? r.data : r;
        if (!d) return;
        if (!renderGate(d)) return;
        renderBuckets(d); renderEvolution(d); renderSurvival(d);
        segScope(d.scoped_segment);
      })
      .catch(function (e) {
        var g = q("gate");
        if (g) { g.hidden = false; g.innerHTML = '<div class="vlt-gate-in"><b>'+TT('visi.js.could_not_load_lifetime')+'</b><p>'
          + esc((e && e.message) || "request failed") + "</p></div>"; }
      });
  }

  (function initRange() {
    function iso(d) { return d.toISOString().slice(0, 10); }
    var a = q("from"), b = q("to");
    /* 90 days by default: a 30-day window cannot show a lifetime. */
    if (a && !a.value) a.value = iso(new Date(Date.now() - 89 * 864e5));
    if (b && !b.value) b.value = iso(new Date());
    [a, b].forEach(function (el) { if (el) el.addEventListener("change", load); });
  })();

  _rpInit(); document.addEventListener("gs:ready", load, { once: true });
  if (window.GS && GS.site) load();
})();
